import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import './styles.css'
import withToast from '../../hocs/withToast';
import axios from "axios";
import { URL } from "../../configs/config";

const API_BASE_URL = URL.LOCAL.getApiKey;
const GRAPHQL_URL = URL.LOCAL.graphQlAdmin;

function ForgetPasswordModal({ isOpen, onClose, notify }) {
    const [email, setEmail] = useState('');

    const handleEmailChange = (e) => setEmail(e.target.value);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {

            const query = `
            mutation password {
                forgetPassword(emailId: "${email}") {
                    statusCode
                    body
                }
            }`;
 
            const variables = null;
 
            const graphqlRes = await axios.post(
                GRAPHQL_URL,
                {
                    query,
                    variables,
                    operationName: "password"
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        "x-api-key": 'da2-zvscgedmvnaufpbli7duwh4dhy',
                        "access-method": "WEB"
                    }
                }
            );
 
            const result = graphqlRes.data.data.forgetPassword;
            const message = JSON.parse(result.body)?.message || "Sent successfully.";
            notify(message, "success");
        } catch (error) {
            console.error("Error:", error);
            notify("Something went wrong while sending forgot password link.", "error");
        }
        setEmail('');
        onClose();
    };

    return (
        <Modal show={isOpen} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title className="text-uppercase text-secondary">
                    Forget Password
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    <Form.Group controlId="email" className="mb-3">
                        <Form.Label>
                            Email Id: <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                            type="email"
                            placeholder="Email Id"
                            value={email}
                            onChange={handleEmailChange}
                            required
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="light" onClick={onClose}>
                        Cancel
                    </Button>
                    <Button variant="primary" type="submit">
                        Email Password Reset Link
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default withToast(ForgetPasswordModal);
